export const UserViewConfig: UserViewConfig = {
  cards: [
    {
      title: "User Details",
      type: "user",
      userId: "",
      status: "Active",
      imageUrl: "",
      fields: [
        {
          label: "Name",
          value: "N/A",
          type: "text",
          key: "name",
          isVisible: true
        },
        {
          label: "Gender",
          value: "N/A",
          type: "text",
          key: "gender",
          isVisible: true
        },
        {
          label: "Parent Name",
          value: "N/A",
          type: "text",
          key: "parentName",
          isVisible: true
        },
        {
          label: "Phone No",
          value: "N/A",
          type: "text",
          key: "phone",
          isVisible: true
        },
        {
          label: "Secondary Number",
          value: "N/A",
          type: "text",
          key: "userSecondaryNumber",
          isVisible: true
        },
        {
          label: "Email",
          value: "N/A",
          type: "text",
          key: "email",
          isVisible: true
        },
        {
          label: "Admission No",
          value: "N/A",
          type: "text",
          key: "admissionNo",
          isVisible: true
        },
        {
          label: "Class",
          value: "N/A",
          type: "text",
          key: "className",
          isVisible: true
        },
        {
          label: "Section",
          value: "N/A",
          type: "text",
          key: "sectionName",
          isVisible: true
        },
        {
          label: "Pick UP",
          value: "N/A",
          type: "array",
          key: "pickup",
          isVisible: true
        },
        {
          label: "Drop",
          value: "N/A",
          type: "array",
          key: "drop",
          isVisible: true
        },
        {
          label: "Emergency Contact No",
          value: "N/A",
          type: "text",
          key: "contactNo",
          isVisible: false
        },
        {
          label: "Destination",
          value: "N/A",
          type: "text",
          key: "destination",
          isVisible: false
        },
        {
          label: "RFID",
          value: "N/A",
          type: "text",
          key: "rfid",
          isVisible: false
        },
        {
          label: "RFID No",
          value: "N/A",
          type: "text",
          key: "rfidNo",
          isVisible: true
        },
        {
          label: "Start Date",
          value: "N/A",
          type: "date",
          key: "startDate",
          isVisible: false
        },
        {
          label: "End Date",
          value: "N/A",
          type: "date",
          key: "endDate",
          isVisible: false
        },
        {
          label: "User Role",
          value: "N/A",
          type: "date",
          key: "role",
          isVisible: false
        },
        {
          label: "User Type",
          value: "N/A",
          type: "date",
          key: "type",
          isVisible: false
        }
      ]
    },
    {
      title: "Employee Details",
      type: "employee",
      fields: [
        {
          label: "Employee ID",
          value: "N/A",
          type: "text",
          key: "employeeId",
          isVisible: true
        },
        {
          label: "Department",
          value: "N/A",
          type: "text",
          key: "empDept",
          isVisible: true
        },
        {
          label: "Designation",
          value: "N/A",
          type: "text",
          key: "department",
          isVisible: true
        },
        {
          label: "Employment Type",
          value: "N/A",
          type: "text",
          key: "employeeType",
          isVisible: true
        },
        {
          label: "Agency",
          value: "N/A",
          type: "text",
          key: "agency",
          isVisible: true
        },
        {
          label: "Category",
          value: "N/A",
          type: "text",
          key: "category",
          isVisible: true
        },
        {
          label: "Shift",
          value: "N/A",
          type: "text",
          key: "shift",
          isVisible: true
        },
        {
          label: "Pick UP",
          value: "N/A",
          type: "array",
          key: "pickup",
          isVisible: true
        },
        {
          label: "Drop",
          value: "N/A",
          type: "array",
          key: "drop",
          isVisible: true
        }
      ]
    }
    /*{
      title: "Student Details",
      type: "student",
      fields: [
        {
          label: "Student ID",
          value: "N/A",
          type: "text",
          key: "studentId",
          isVisible: true
        },
        {
          label: "Class",
          value: "N/A",
          type: "text",
          key: "className",
          isVisible: true
        },
        {
          label: "Section",
          value: "N/A",
          type: "text",
          key: "sectionName",
          isVisible: true
        },
        {
          label: "Admission No",
          value: "N/A",
          type: "text",
          key: "admissionNo",
          isVisible: true
        },
        {
          label: "Pick UP",
          value: "N/A",
          type: "array",
          key: "pickup",
          isVisible: true
        },
        {
          label: "Drop",
          value: "N/A",
          type: "array",
          key: "drop",
          isVisible: true
        }
      ]
    }*/
  ]
};
